module.exports = __webpack_public_path__ + "static/media/product-information-uniservice.b4d36797.pdf";